import ShareableLinkWithdrawnLead from './ShareableLinkWithdrawnLead.component';

export default ShareableLinkWithdrawnLead;
